import styled from 'styled-components';

export const UserContainer = styled.div`
  display: flex;
  flex-direction: 'row';
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
  line-height: 20px;
  &:last-child {
    margin: 0;
  }
`;

export const UserName = styled.span`
  margin-left: 10px;
`;